var map = {
	"./colheitadeira.svg": 689,
	"./colheitadeira2.svg": 690,
	"./machine-empty.svg": 428,
	"./machine-occupied.svg": 691,
	"./pedestrian.svg": 369,
	"./polinizador.svg": 692,
	"./pulverizador.svg": 693,
	"./pulverizador2.svg": 694,
	"./truck9.svg": 695,
	"./truck9b.svg": 696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1444;